import React from 'react';
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import {bindActionCreators, compose} from "redux";
import {translate} from "react-i18next";

import * as propTypes from '../../common/propTypes';
import NewsDetail from './NewsDetail';
import {getRowById} from "../../reducers/tableReducer";
import {updateNews} from "../../actions/newsActions";
import {navigateToNews} from "../../actions/navigationActions";

const NewsDetailUpdate = ({initialValues, updateNews, cancelAction, t}) => {
  return <NewsDetail initialValues={initialValues} onSubmit={updateNews} headerText={t('UpdateNews')+ ' - ' +initialValues.name} onCancel={cancelAction}/>;
};

NewsDetailUpdate.propTypes = {
  initialValues: propTypes.newsPropTypes.isRequired,
  updateNews: PropTypes.func.isRequired,
  cancelAction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, {match}) => {
  const id = match.params.id;

  return {
    lang: state.app.lang,
    initialValues: getRowById(state, id)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNews: bindActionCreators(updateNews, dispatch),
    cancelAction: bindActionCreators(navigateToNews, dispatch)
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), translate('common'))(NewsDetailUpdate);

